import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "filter weekly-wrapper mx-auto mx-md-0",
  ref: "weeklyNav"
}
const _hoisted_2 = {
  key: 0,
  class: "date-navigation d-flex me-2",
  id: "weekly-date"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left date-change-icon cursor-pointer" }, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "mx-2 formatted-date" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right date-change-icon cursor-pointer" }, null, -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "weekly-picker text-dark" }
const _hoisted_9 = {
  ref: "weekDatePicker",
  class: "schedule-calendar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.formattedDateRange)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", {
            class: _normalizeClass(`cursor-pointer px-2 ${_ctx.disabled || _ctx.isPrevDisabled ? 'disabled' : ''}`),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.backwardNavigation()))
          }, _hoisted_4, 2 /* CLASS */),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.formattedDateRange), 1 /* TEXT */),
          _createElementVNode("span", {
            class: _normalizeClass(`calendar-icon cursor-pointer px-1 ${_ctx.showCalendar ? 'active' : ''}`),
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleCalendar && _ctx.toggleCalendar(...args)))
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(`fas fa-calendar-alt ${_ctx.showCalendar ? 'active' : ''}`)
            }, null, 2 /* CLASS */)
          ], 2 /* CLASS */),
          _createElementVNode("span", {
            class: _normalizeClass(`cursor-pointer px-2 ${_ctx.disabled || _ctx.isNextDisabled ? 'disabled' : ''}`),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.forwardNavigation()))
          }, _hoisted_7, 2 /* CLASS */),
          _withDirectives(_createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, null, 512 /* NEED_PATCH */)
          ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.showCalendar]
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}